// src/components/Footer.jsx
import React, { useMemo } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className="ggf-footer mt-5" aria-label="Pied de page">
      <div className="container py-5">
        {/* Top grid */}
        <div className="row g-4 align-items-start">
          {/* Brand */}
          <div className="col-12 col-lg-4">
            <div className="d-flex align-items-center gap-3 mb-3">
              <img
                src="/logo192.png"
                alt="GOD'S GIFT FASHION"
                width="120"
                height="auto"
                loading="lazy"
                style={{ display: "block" }}
              />
              <div>
                {/* <div className="fw-black h5 m-0">GOD&apos;S GIFT FASHION</div> */}
                <div className="fw-black small">Prêt-à-porter • Lomé• Togo</div>
              </div>
            </div>

            <p className="fw-black small mb-3" style={{ maxWidth: 420 }}>
              Des tenues tendance pour tous vos styles. Qualité, prix accessibles et
              nouveautés régulières — commande simple et rapide.
            </p>

            {/* Trust pills */}
            <div className="d-flex flex-wrap gap-2">
              <span className="ggf-pill">
                <i className="bi bi-shield-check" /> Achat sécurisé
              </span>
              <span className="ggf-pill">
                <i className="bi bi-box-seam" /> Produits vérifiés
              </span>
              <span className="ggf-pill">
                <i className="bi bi-headset" /> Support WhatsApp
              </span>
            </div>
          </div>

          {/* Links */}
          <div className="col-6 col-lg-2">
            <h6 className="ggf-title">Navigation</h6>
            <ul className="list-unstyled m-0 d-grid gap-2">
              <li><Link to="/" className="ggf-link">Accueil</Link></li>
              <li><Link to="/catalogue" className="ggf-link">Catalogue</Link></li>
              <li><Link to="/orders/lookup-phone" className="ggf-link">Mes commandes</Link></li>
              <li><Link to="/contact" className="ggf-link">Contact</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h6 className="ggf-title">Informations</h6>
            <ul className="list-unstyled m-0 d-grid gap-2">
              <li><Link to="/privacy" className="ggf-link">Confidentialité</Link></li>
              <li><Link to="/terms" className="ggf-link">Conditions</Link></li>
              <li><Link to="/shipping" className="ggf-link">Livraison</Link></li>
              <li><Link to="/returns" className="ggf-link">Retours</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-12 col-lg-4">
            <h6 className="ggf-title">Contact</h6>

            <div className="ggf-card p-3">
              <div className="d-grid gap-2">
                <div className="d-flex align-items-start gap-2">
                  <i className="bi bi-geo-alt ggf-ico" />
                  <div>
                    <div className="fw-semibold">Lomé, Togo</div>
                    <div className="text-muted small">Disponibles en ligne & en boutique</div>
                  </div>
                </div>

                <a className="ggf-contact" href="tel:+22871328822">
                  <i className="bi bi-telephone ggf-ico" />
                  <span>+228 71 32 88 22</span>
                </a>

                <a className="ggf-contact" href="mailto:">
                  <i className="bi bi-envelope ggf-ico" />
                  <span></span>
                </a>

                <a
                  className="ggf-contact ggf-wa"
                  href="https://wa.me/22871328822"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-whatsapp ggf-ico" />
                  <span>Commander / Assistance WhatsApp</span>
                  <i className="bi bi-arrow-up-right ms-auto" />
                </a>
              </div>
            </div>

            {/* Socials */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              <a className="ggf-social" href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
                <i className="bi bi-facebook" />
              </a>
              <a className="ggf-social" href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">
                <i className="bi bi-instagram" />
              </a>
              <a className="ggf-social" href="https://tiktok.com" aria-label="TikTok" target="_blank" rel="noreferrer">
                <i className="bi bi-tiktok" />
              </a>
              <a className="ggf-social" href="https://wa.me/22871328822" aria-label="WhatsApp" target="_blank" rel="noreferrer">
                <i className="bi bi-whatsapp" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="ggf-hr my-4" />

        {/* Bottom bar */}
        <div className="d-flex flex-column flex-md-row gap-2 align-items-center justify-content-between">
          <div className="text-muted small">
            © {year} <span className="text-light fw-semibold">GOD&apos;S GIFT FASHION</span> — Tous droits réservés.
          </div>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <span className="ggf-mini">Paiement à la livraison</span>
            <span className="ggf-dot">•</span>
            <span className="ggf-mini">Nouveautés chaque semaine</span>
            <span className="ggf-dot">•</span>
            <span className="ggf-mini">Support réactif</span>
          </div>
        </div>
      </div>

      <style>{`
        .ggf-footer{
          background:
            radial-gradient(1200px 500px at 10% 0%, rgba(255,255,255,.10), transparent 60%),
            radial-gradient(900px 420px at 90% 20%, rgba(255,255,255,.08), transparent 55%),
            #0b1226;
          color: #fff;
          border-top: 1px solid rgba(255,255,255,.08);
        }

        .fw-black{ font-weight: 900; }

        .ggf-title{
          font-weight: 900;
          margin-bottom: 12px;
          letter-spacing: .2px;
        }

        .ggf-link{
          color: rgba(255,255,255,.78);
          text-decoration: none;
          font-weight: 700;
        }
        .ggf-link:hover{
          color: #fff;
          text-decoration: underline;
        }

        .ggf-pill{
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 10px;
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,.10);
          background: rgba(255,255,255,.06);
          color: rgba(255,255,255,.86);
          font-size: 12px;
          font-weight: 800;
        }

        .ggf-card{
          border-radius: 16px;
          border: 1px solid rgba(255,255,255,.10);
          background: rgba(255,255,255,.06);
          box-shadow: 0 16px 40px rgba(0,0,0,.20);
          backdrop-filter: blur(10px);
        }

        .ggf-ico{
          font-size: 18px;
          line-height: 1;
          margin-top: 2px;
          opacity: .95;
        }

        .ggf-contact{
          display:flex;
          align-items:center;
          gap:10px;
          padding: 10px 10px;
          border-radius: 12px;
          text-decoration:none;
          color: rgba(255,255,255,.88);
          border: 1px solid rgba(255,255,255,.08);
          background: rgba(0,0,0,.12);
        }
        .ggf-contact:hover{
          color:#fff;
          background: rgba(0,0,0,.18);
        }
        .ggf-wa{
          border-color: rgba(25,135,84,.35);
          background: rgba(25,135,84,.16);
        }
        .ggf-wa:hover{
          background: rgba(25,135,84,.22);
        }

        .ggf-social{
          width: 44px;
          height: 44px;
          border-radius: 999px;
          display:grid;
          place-items:center;
          text-decoration:none;
          color:#fff;
          border: 1px solid rgba(255,255,255,.10);
          background: rgba(255,255,255,.06);
          transition: transform .15s ease, background .15s ease;
        }
        .ggf-social:hover{
          transform: translateY(-2px);
          background: rgba(255,255,255,.10);
          color:#fff;
        }

        .ggf-hr{
          border-color: rgba(255,255,255,.12);
          opacity: 1;
        }

        .ggf-mini{
          color: rgba(255,255,255,.70);
          font-size: 12px;
          font-weight: 800;
        }
        .ggf-dot{
          color: rgba(255,255,255,.35);
          font-weight: 900;
        }

        @media (max-width: 576px){
          .ggf-title{ margin-bottom: 10px; }
        }
      `}</style>
    </footer>
  );
}
